import React from 'react';
import { createSvgIcon } from '@mui/material';

const CustomCc = createSvgIcon(
  <path d="M10.2 10.8c.3 0 .6-.3.6-.6v-.6c0-.7-.5-1.2-1.2-1.2H6c-.7 0-1.2.5-1.2 1.2v4.8c0 .7.5 1.2 1.2 1.2h3.6c.7 0 1.2-.5 1.2-1.2v-.6c0-.3-.3-.6-.6-.6h-.6c-.3 0-.6.3-.6.6H6.6v-3.6H9c0 .3.3.6.6.6zm8.4 0c.3 0 .6-.3.6-.6v-.6c0-.7-.5-1.2-1.2-1.2h-3.6c-.7 0-1.2.5-1.2 1.2v4.8c0 .7.5 1.2 1.2 1.2H18c.7 0 1.2-.5 1.2-1.2v-.6c0-.3-.3-.6-.6-.6H18c-.3 0-.6.3-.6.6H15v-3.6h2.4c0 .3.3.6.6.6z" />,
  'CustomCc',
);

export default CustomCc;
